import {CommandBase} from "./commandBase";
import {Metadata, RemoteConstantsModel} from "../models/remoteConstants.model";
import {SetAttributeLocalizationCommand} from "./setAttributeLocalization.command";
import {mintNamespacedUid} from "../utils/uid.utils";

export class AddTechAttributeCommand extends CommandBase {
    id: string;
    action: boolean;

    constructor(id: string, action: boolean) {
        super();
        this.id = id;
        this.action = action;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (this.id === '') {
            return false;
        }

        if (this.action) {
            data.techActionAttributes = this.addToCollection(data, this.id, data.techActionAttributes)
        } else {
            data.techPassiveAttributes = this.addToCollection(data, this.id, data.techPassiveAttributes)
        }

        return true;
    }

    private addToCollection(data: RemoteConstantsModel, attribute: string, attributes: Metadata[]): Metadata[] {
        if (attributes === undefined || attributes === null) {
            attributes = [];
        }

        const uid = this.mintUid(data, attribute);
        new SetAttributeLocalizationCommand(uid, this.id).execute(data);

        attributes.push({
            uid: uid,
            id: attribute,
            active: true,
            values: {},
            entities: {}
        });

        return attributes;
    }

    // `techaction.<slug>.<n>` / `techpassive.<slug>.<n>` — see uid.utils.ts.
    private mintUid(data: RemoteConstantsModel, id: string): string {
        const prefix = this.action ? 'techaction' : 'techpassive';
        return mintNamespacedUid(prefix, id, [
            ...(data.techActionAttributes ?? []).map(m => m.uid),
            ...(data.techPassiveAttributes ?? []).map(m => m.uid),
        ]);
    }
}
